module.exports = __webpack_public_path__ + "static/img/Captura de tela de 2024-11-05 15-01-42.9a85bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Captura de tela de 2024-11-05 15-01-42.png
// module id = xFqf
// module chunks = 4